module.exports = __webpack_public_path__ + "068fdc875e8cb0b4ceef956074edbd97.svg";